import { getEvent } from '../../api/ApiManager';
import { LOAD_EVENT_DETAILS } from '../../routes/EventDetails/modules/constants';
import { put, select, takeLatest } from 'redux-saga/effects';
import {
  loadEventDetailsSuccess,
  loadEventDetailsFailure,
  getOfferById,
  loadEventDetailsBegin,
  loadPortalEventDetails,
  clearTemplateOffers,
  updateNotifications,
  loadEventDetailsAbort,
} from '../../routes/EventDetails/modules/eventDetails';
import { alignEventProperties } from '../lib/Events/index';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import find from 'lodash/find';
import get from 'lodash/get';
import { browserHistory } from 'react-router';

export function* eventDetailsSaga(action) {
  const globalState = yield select();
  const contextId = globalState.app.contextId;
  const eventId = action.eventId;
  const currentEvent = globalState.event_details.eventInView;
  const lastFetched = globalState.event_details.lastFetched;
  const hasBeen5MinutesSinceLastFetch =
    Math.floor(new Date() - lastFetched) / 1000 > 300;
  const recentlySavedData =
    globalState.app.notification && globalState.app.notification.message;
  const shouldFetchData =
    !currentEvent ||
    (currentEvent && Number(currentEvent) !== Number(eventId)) ||
    recentlySavedData ||
    hasBeen5MinutesSinceLastFetch;

  if (currentEvent && Number(currentEvent) !== Number(eventId)) {
    yield put(clearTemplateOffers());
  }

  if (action.portalId) {
    // find event locally
    const events = globalState.event_chron.events;
    const portalEvent = find(events, { portalId: Number(action.portalId) });
    yield put(loadPortalEventDetails(portalEvent));
  } else if (shouldFetchData) {
    // TODO consider switching this if / else logic around
    yield put(loadEventDetailsBegin());
    try {
      const request = getEvent(contextId, eventId);
      const response = yield request;
      const errorCode = get(response, 'data.ResponseStatus.ErrorCode');
      if (errorCode) {
        throw { Message: get(response, 'data.ResponseStatus.Message') };
      }
      const event = alignEventProperties(
        camelcaseKeysDeep(response.data.Event)
      );
      yield put(loadEventDetailsSuccess(event, true));
      if (action.rules && action.rules.fetch === 'offer') {
        const offerId = action.rules.offerId || null;
        yield put(getOfferById(offerId, action.rules));
      }
    } catch (err) {
      yield put(
        updateNotifications(
          'Failed to load event. The server returned: ' + err.Message,
          'error',
          true
        )
      );
      yield put(loadEventDetailsFailure(err));
      browserHistory.push('/events');
    }
  } else {
    // abort
    yield put(loadEventDetailsAbort());
  }
}

export function* eventDetailsSagaWatcher() {
  yield takeLatest(LOAD_EVENT_DETAILS, eventDetailsSaga);
}



// WEBPACK FOOTER //
// ./src/common/sagas/events.js